<template>
   <div class="logos-clientes">
    <h1 class="titulo-home mt-5">NUESTROS CLIENTES</h1>
    <VueSlickCarousel  v-bind="settings" >
      <div v-for="logo, index in logos" :key="index">
        <img :src="logo.img" :alt="logo.nombre"/>
        
      </div>
      {{logos}}
    </VueSlickCarousel>
  </div>
</template>

<script>

 import VueSlickCarousel from 'vue-slick-carousel'
  import 'vue-slick-carousel/dist/vue-slick-carousel.css'
  // optional style for arrows & dots
  import 'vue-slick-carousel/dist/vue-slick-carousel-theme.css'

  let logos=[
      {"nombre": "Tomglen sabor mexicano","img": require('../assets/img/logos/tomglen.png') },
      {"nombre": "La Perrera","img": require('@/assets/img/logos/laperrera.png') },
      {"nombre": "Chiken Wings","img": require('@/assets/img/logos/chikenwings.png') },
      {"nombre": "Salchipapotas de Alex","img": require('@/assets/img/logos/salchipapotasdealex.png') },
      {"nombre": "Angelatos","img": require('@/assets/img/logos/angelatos.png') },
      {"nombre": "warner Foods","img": require('@/assets/img/logos/warnerfoods.png') },
      {"nombre": "La Estacion","img": require('@/assets/img/logos/laestacion.png') },
      {"nombre": "Mr. Sandwich","img": require('@/assets/img/logos/mrsandwich.png') },
      {"nombre": "La comisaria","img": require('@/assets/img/logos/lacomisaria.png') },
      {"nombre": "Banana","img": require('@/assets/img/logos/banana.png') },
      {"nombre": "Barbaros","img": require('@/assets/img/logos/barbaros.png') },
      {"nombre": "Asados y parrillas del Valle","img": require('@/assets/img/logos/asadosyparrillasdelvalle.png') },
      {"nombre": "Benditas ALas","img": require('@/assets/img/logos/benditasalas.png') },
      {"nombre": "Bueger Box","img": require('@/assets/img/logos/burgerbox.png') },
      {"nombre": "Bendito Hot Dogs","img": require('@/assets/img/logos/benditoshotdogs.png') },
      {"nombre": "Brasa Imperial","img": require('@/assets/img/logos/brasaimperial.png') },
      {"nombre": "Burgervard","img": require('@/assets/img/logos/burgervard.png') },
      {"nombre": "Capital Food","img": require('@/assets/img/logos/capitalfood.png') },
      {"nombre": "Carbon Street","img": require('@/assets/img/logos/carbonstreet.png') },
      {"nombre": "CBC Burger","img": require('@/assets/img/logos/cbc.png') },
      {"nombre": "City Papas","img": require('@/assets/img/logos/citypapas.png') },
      {"nombre": "Classic Burger","img": require('@/assets/img/logos/classicburger.png') },
      {"nombre": "Comiendo Ando","img": require('@/assets/img/logos/comiendoando.png') },
      {"nombre": "Crazy Hot Dog","img": require('@/assets/img/logos/crazyhotdog.png') },
      {"nombre": "Cubanito","img": require('@/assets/img/logos/cubanito.png') },
      {"nombre": "Cubanito Fast Food","img": require('@/assets/img/logos/cubanitosfastfood.png') },
      {"nombre": "Doña Oliva","img": require('@/assets/img/logos/donaoliva.png') },
      {"nombre": "Don Quijote","img": require('@/assets/img/logos/donquijote.png') },
      {"nombre": "El Origen","img": require('@/assets/img/logos/elorigen.png') },
      {"nombre": "el Rancho de Baruk","img": require('@/assets/img/logos/elranchodebaruk.png') },
      {"nombre": "Fusión","img": require('@/assets/img/logos/fusion.png') },
      {"nombre": "Gatton","img": require('@/assets/img/logos/gatton.png') },
      {"nombre": "Gordos Inc","img": require('@/assets/img/logos/gordosinc.png') },
      {"nombre": "Kan Can","img": require('@/assets/img/logos/kancan.png') },
      {"nombre": "La 5ta Estación","img": require('@/assets/img/logos/la5taestacion.png') },
      {"nombre": "La Banda del Chori","img": require('@/assets/img/logos/labandadelchori.png') },
      {"nombre": "La Burguesa","img": require('@/assets/img/logos/laburguesa.png') },
      {"nombre": "La Casa del Asado","img": require('@/assets/img/logos/lacasadelasado.png') },
      {"nombre": "La Loma","img": require('@/assets/img/logos/laloma.png') },
      {"nombre": "La Mascotería","img": require('@/assets/img/logos/lamascoteria.png') },
      {"nombre": "La Morsa","img": require('@/assets/img/logos/lamorsa.png') },
      {"nombre": "La Ppatrona","img": require('@/assets/img/logos/lapatrona.png') },
      {"nombre": "La Rama de mi Apa","img": require('@/assets/img/logos/laramadademiapa.png') },
      {"nombre": "Lasaga","img": require('@/assets/img/logos/lasaga.png') },
      {"nombre": "La Selecta","img": require('@/assets/img/logos/laselecta.png') },
      {"nombre": "Maderos y Carbón","img": require('@/assets/img/logos/maderosycarbon.png') },
      {"nombre": "Magic","img": require('@/assets/img/logos/magic.png') },
      {"nombre": "Magic Burger","img": require('@/assets/img/logos/magicburger.png') },
      {"nombre": "Matambre","img": require('@/assets/img/logos/matambre.png') },
      {"nombre": "Mono","img": require('@/assets/img/logos/mono.png') },
      {"nombre": "Patacos","img": require('@/assets/img/logos/patacos.png') },
      {"nombre": "Perros Chichu","img": require('@/assets/img/logos/perroschichu.png') },
      {"nombre": "Punto Angus","img": require('@/assets/img/logos/puntoangus.png') },
      {"nombre": "Sabor Extremo","img": require('@/assets/img/logos/saborextremo.png') },
      {"nombre": "Sanducheo","img": require('@/assets/img/logos/sanducheo.png') },
      {"nombre": "Smoky","img": require('@/assets/img/logos/smoky.png') },
      {"nombre": "Supla","img": require('@/assets/img/logos/supla.png') },
      {"nombre": "Two x Dogs","img": require('@/assets/img/logos/twodocs.png') },
      {"nombre": "V 60","img": require('@/assets/img/logos/v-60.png') },
      {"nombre": "Vegfit","img": require('@/assets/img/logos/vegfit.png') },
      {"nombre": "Xl Snacks","img": require('@/assets/img/logos/xlsnacks.png') },
      
     
  ]
    
  export default {
    components: {
     VueSlickCarousel
    },
    name:'slider',
    data() {
      return {
        logos:logos,
        settings:{"arrows": false,
                "dots": false,
                "infinite": true,
                "slidesToShow": 8,
                "slidesToScroll": 8,
                "autoplay": true,
                "speed": 16000,
                "autoplaySpeed": 1000,
                "cssEase": "linear",
               }
      }
    },
    mounted() {
     
    }
  }
</script>

<style lang="scss" scoped>
 

</style>